module.exports = __webpack_public_path__ + "static/media/18a Chin Strap.807df087.jpg";